import React from 'react';
import { getAllGroups } from '../../../models/groups';
import { getAuctionsTracking } from '../../../models/auctions';
import { HomeBanner } from '../../home/homeBanner';
import i18n from '../../../i18n';
import { MzadLoader } from '../../helpers/mzadLoader';
import { SideBar } from '../sidebar';
import ProgressTracker from './components/ProgressTracker';

const objectToQueryString = (obj) => {
  return Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&');
};
export class AuctionTrackerNew extends React.Component {
  constructor() {
    super();
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    this.state = {
      input: { ...params },
      groups: [],
      auctions: [],
      is_loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let { input } = this.state;

    this.loadAllAuctions(input);
    this.loadAllGroups();
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;

    // Remove empty values from URL params
    const cleanInput = Object.fromEntries(Object.entries(input).filter(([_, v]) => v !== ''));

    // Update the URL query params without reloading
    const newQueryString = objectToQueryString(cleanInput);
    const newUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      (newQueryString ? '?' + newQueryString : '');

    window.history.pushState({ path: newUrl }, '', newUrl);

    this.setState({ input });
    this.loadAllAuctions(input);
  }

  handleClear = () => {
    const clearedInput = { type: '', group: '' };

    // Remove query params from URL
    const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

    window.history.pushState({ path: newUrl }, '', newUrl);

    this.setState({ input: clearedInput }, () => {
      this.loadAllAuctions(clearedInput);
    });
  };

  async loadAllGroups() {
    let q = '';
    const response = await getAllGroups(q);
    let groups = response.data;
    this.setState({ groups });
  }

  async loadAllAuctions(params) {
    let q = '';
    if (typeof params !== undefined && params) {
      q = objectToQueryString(params);
    }
    this.setState({ is_loading: true });
    const response = await getAuctionsTracking(`?${q}`);
    if (response) {
      let auctions = response.data;
      let meta = response.meta;
      this.setState({ totalRows: meta.total });
      this.setState({ auctions: auctions, is_loading: false });
    }
  }

  render() {
    let { auctions, groups } = this.state;
    return (
      <React.Fragment>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">{!this.state.hideSidebar && <SideBar />}</div>
              <div
                className={this.state.hideSidebar ? 'col-xl-12 col-lg-12 col-md-12' : 'col-xl-9 col-lg-12 col-md-12'}
              >
                <div className="card mb-0">
                  <div className="card-header d-flex justify-content-between track-head">
                    <h3 className="card-title d-flex">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        <img
                          src={process.env.PUBLIC_URL + '/assets/images/gridicons_line-graph.png'}
                          alt=""
                          width="25"
                        />
                      </span>
                      {i18n.t('tracking_auctions')}
                    </h3>

                    <div className="d-flex gap-1">
                      <select
                        className="form-select textbox fs15 text-gray filter-icon rounded-2 w-200"
                        data-placeholder="Select Category"
                        name="type"
                        value={this.state.input.type}
                        onChange={this.handleChange}
                      >
                        <option value="">{i18n.t('select_type')}</option>
                        <option value="active">{i18n.t('active')}</option>
                        <option value="upcoming">{i18n.t('upcoming')}</option>
                        <option value="featured">{i18n.t('featured')}</option>
                        <option value="previous">{i18n.t('previous')}</option>
                        <option value="direct">{i18n.t('direct')}</option>
                      </select>
                      <select
                        className="fform-select textbox fs15 text-gray filter-icon rounded-2 w-200"
                        data-placeholder="Select Group"
                        name="group"
                        value={this.state.input.group}
                        onChange={this.handleChange}
                      >
                        <option value="">{i18n.t('select_group')}</option>
                        {groups.length > 0 &&
                          groups.map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.group_name}
                              </option>
                            );
                          })}
                      </select>
                      {(this.state.input.group || this.state.input.type) && (
                        <button
                          type="button"
                          className="btn btn-outline-dark text-dark rounded-2 px-3 h-100"
                          onClick={this.handleClear}
                        >
                          {i18n.t('clear')}
                        </button>
                      )}
                    </div>
                  </div>

                  <div>
                    {this.state.is_loading && (
                      <div>
                        <MzadLoader
                          animation="grow"
                          size="md"
                          loading={this.state.is_loading}
                          style={{ position: 'relative' }}
                        />
                      </div>
                    )}
                    {!this.state.is_loading && auctions.length > 0 && <ProgressTracker auctions={auctions} />}
                  </div>

                  {!this.state.is_loading && auctions.length === 0 && (
                    <div className="m-3 text-center p-3 text-red">{i18n.t('no_auctions_found')}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
